import { Link, useLocation } from 'react-router-dom';
import "./Mobile_prepaid_plan_card_holder.css";

function Mobile_prepaid_plan_card_holder({changeLink, planName, number,sim_country}) {
    const location = useLocation();

    // Check if current path is "/mobile-prepaid-recharge"
    const isPrepaidRechargePage = location.pathname === "/mobile-prepaid-recharge";

    return (
        <section className='Mobile_prepaid_plan_card_holder'>
            <div className="prepaid_plan_card_holder">
                <div className="row align-items-center">
                    <div className="col-md-2 col-sm-2  col-3">
                        <div className="img_holder">
                            <img
                                src="/assets/images/services/electricity_distribution_logo/electricity_logo.png"
                                alt="Airtel"
                                className='recharge_sim_img'
                            />
                        </div>
                    </div>

                    <div className="col-md-10 col-sm-10  col-9">
                        <div className="text_holder">
                            <div className='card_name_holder'>
                                <h5>{planName}</h5>
                                <div className="number_text_holder">
                                    <p>{number}</p>
                                    <h6>
                                        {sim_country} <Link to={changeLink}><span> Change </span></Link>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Mobile_prepaid_plan_card_holder;
